import { CheckCircleOutlined, CrownOutlined, ExperimentOutlined } from '@ant-design/icons';
import { Card, Statistic, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

interface SystemHealthProps {
	aiScansToday: number;
	activeSubscriptions: number;
	loading?: boolean;
}

const SystemHealth = ({
	aiScansToday,
	activeSubscriptions,
	loading = false,
}: SystemHealthProps) => {
	const { t } = useTranslation('components');

	return (
		<Card
			title={
				<span className='font-semibold text-slate-700'>
					{t('dashboard.systemHealth.title')}
				</span>
			}
			className='border border-slate-100 shadow-sm rounded-xl'
			styles={{ body: { padding: '16px' } }}
			loading={loading}
		>
			<div className='space-y-4'>
				<div className='flex items-center gap-3 p-3 bg-emerald-50 rounded-lg'>
					<CheckCircleOutlined className='text-emerald-500 text-lg' />
					<div>
						<Text className='text-sm font-medium text-emerald-700 block'>
							{t('dashboard.systemHealth.aiService')}
						</Text>
						<Text className='text-xs text-emerald-600'>
							{t('dashboard.systemHealth.operational')}
						</Text>
					</div>
				</div>

				<div className='grid grid-cols-2 gap-3'>
					<div className='p-3 bg-slate-50 rounded-lg'>
						<div className='flex items-center gap-2 mb-1'>
							<ExperimentOutlined className='text-purple-500' />
							<Text className='text-xs text-slate-500'>
								{t('dashboard.systemHealth.scansToday')}
							</Text>
						</div>
						<Statistic value={aiScansToday} valueStyle={{ fontSize: '20px', fontWeight: 'bold' }} />
					</div>

					<div className='p-3 bg-slate-50 rounded-lg'>
						<div className='flex items-center gap-2 mb-1'>
							<CrownOutlined className='text-amber-500' />
							<Text className='text-xs text-slate-500'>
								{t('dashboard.systemHealth.proSubs')}
							</Text>
						</div>
						<Statistic value={activeSubscriptions} valueStyle={{ fontSize: '20px', fontWeight: 'bold' }} />
					</div>
				</div>
			</div>
		</Card>
	);
};

export { SystemHealth };
export default SystemHealth;
